import { saveAs } from 'file-saver';

import { useApiQuery } from "theSource/utils";
import { useConfigurationQuery } from "theSource/queries";
import { DownloadTaxDocumentResponseDto, DOWNLOAD_TAX_DOCUMENT_KEY } from "./utils";
import { base64ToBlob } from 'enrollment/utils/FileUtils/base64blob';

interface DownloadTaxDocumentRequestProps {
  formId: number;
  onSuccess?: () => void;
  onError?: () => void;
}

export const useDownloadTaxDocumentQuery = ({
  formId,
  onSuccess,
  onError,
}: DownloadTaxDocumentRequestProps) => {
  const { configuration } = useConfigurationQuery();
  const lumosApiHost = configuration?.apiHost;

  const {
    data,
    isLoading,
    refetch,
  } = useApiQuery<DownloadTaxDocumentResponseDto>({
    queryKey: `${DOWNLOAD_TAX_DOCUMENT_KEY}-${formId}`,
    endpoint: `/document_library/1095c/${formId}`,
    config: {
      baseURL: `${lumosApiHost}/v1/self_service`,
    },
    showErrorSnackbar: true,
    enabled: false, // disable auto-fetching and only fetch on demand
    onSuccess: (data) => {
      const fileData = data.data.file_data;
      const fileName = data.data.file_name;
      const fileType = data.data.content_type;
      const blob = base64ToBlob(fileData, fileType as any);
      if (blob) {
        saveAs(blob, fileName);
      }
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      if (onError) {
        onError();
      }
    },
  });

  return {
    data,
    isLoading,
    refetch,
  };
};
